import loadable from '@loadable/component';

export const AlignWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/AlignWidget'
    ),
);

export const ButtonsWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ButtonsWidget'
    ),
);

export const ArrayWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ArrayWidget'
    ),
);

export const CheckboxWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/CheckboxWidget'
    ),
);

export const CheckboxGroupWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/CheckboxGroupWidget'
    ),
);

export const FileWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/FileWidget'
    ),
);

export const HiddenWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/HiddenWidget'
    ),
);

export const IdWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/IdWidget'
    ),
);

export const PasswordWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/PasswordWidget'
    ),
);

export const QueryWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/QueryWidget'
    ),
);

export const QuerySortOnWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/QuerySortOnWidget'
    ),
);

export const QuerystringWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/QuerystringWidget'
    ),
);

export const RadioGroupWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/RadioGroupWidget'
    ),
);

export const SchemaWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/SchemaWidget'
    ),
);

export const SelectWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/SelectWidget'
    ),
);

export const StaticTextWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/StaticTextWidget'
    ),
);

export const TextareaWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/TextareaWidget'
    ),
);

export const TextWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/TextWidget'
    ),
);

export const TokenWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/TokenWidget'
    ),
);

export const WysiwygWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/WysiwygWidget'
    ),
);

export const UrlWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/UrlWidget'
    ),
);

export const InternalUrlWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/InternalUrlWidget'
    ),
);

export const EmailWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/EmailWidget'
    ),
);

export const NumberWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/NumberWidget'
    ),
);

export const ImageSizeWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ImageSizeWidget'
    ),
);

export const RegistryImageWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/RegistryImageWidget'
    ),
);

export const ReferenceWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ReferenceWidget'
    ),
);

export const ObjectBrowserWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ObjectBrowserWidget'
    ),
);

export const ObjectWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ObjectWidget'
    ),
);

export const ObjectListWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ObjectListWidget'
    ),
);

export const VocabularyTermsWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/VocabularyTermsWidget'
    ),
);

export const SelectMetadataWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Blocks/Search/widgets/SelectMetadataField'
    ),
);

export const SelectAutoComplete = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/SelectAutoComplete'
    ),
);

export const ColorPickerWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/ColorPickerWidget'
    ),
);

export const DatetimeWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/DatetimeWidget'
    ),
);

export const TimeWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/TimeWidget'
    ),
);

export const RecurrenceWidget = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/RecurrenceWidget/RecurrenceWidget'
    ),
);

export const FormFieldWrapper = loadable(
  () =>
    import(
      /* webpackChunkName: "Widgets" */ '@plone/volto/components/manage/Widgets/FormFieldWrapper'
    ),
);
